'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivityCtrl', ActivityCtrl);

  ActivityCtrl.$inject = ['$scope', 'activity', 'responses', 'msAuth', '$state', '$log', '$q', 'activitySvc', 'trainSvc', 'widgetSvc', 'NotifyingSvc', 'activityRouter', 'eventTrackingSvc'];

  /* @ngInject */
  function ActivityCtrl($scope, activity, responses, msAuth, $state, $log, $q, activitySvc, trainSvc, widgetSvc, NotifyingSvc, activityRouter, eventTrackingSvc) {
    var vm = this;
    vm.title = 'ActivityDetailCtrl';
    vm.$onInit = activate;

    ////////////////

    function activate() {
      $log.debug('Activity ctrl activate');
      vm.isLoggedIn = msAuth.isLoggedIn();
      vm.activity = activity;
      for (var i in responses) {
        if (activity.url === responses[i].activity.url) {
          vm.responses = responses[i].responses;
        }
      }
      if (vm.responses) {
        vm.responses = _.orderBy(vm.responses, ['modifiedOn'], ['desc']);
      }
      vm.parent = trainSvc.getParent(activity);
      if (vm.activity.publicView && $state.current.url === 'intro') {
        eventTrackingSvc.fireEvent('activity', 'publicIntro', vm.activity.url);
      }
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
        pageTitle: vm.activity.title
      });
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ACTIVITY_STARTED, {
        activity: vm.activity
      });
    }

    $scope.save = function () {
      trainSvc.setStatus(vm.activity, 'COMPLETED');
      if (vm.activity.publicView) {
        eventTrackingSvc.fireEvent('activity', 'publicDone', vm.activity.url, { activity: vm.activity.id });
      } else {
        eventTrackingSvc.fireEvent('activity', 'done', vm.activity.url, { activity: vm.activity.id });
      }
      activitySvc.saveResponses(vm.activity).then(function () {
        activityRouter.giveFeedback();
      });
    };

    $scope.findResponse = function (widgetUuid) {
      var widget = widgetSvc.getByUuid(activity, widgetUuid);
      return !widget ? '' : widget.response;
    };
  }
})();